export default __webpack_public_path__ + "static/Hero_02b_CEOLetter_REV-28e503297b74dce117f4509bcc48f5bb.jpg";